import { render, staticRenderFns } from "./MotifConsultation.vue?vue&type=template&id=1bada98c"
import script from "./MotifConsultation.vue?vue&type=script&lang=js"
export * from "./MotifConsultation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports